// extracted by mini-css-extract-plugin
export default {"logo":"client-logo_logo__7kpvB"};